(function () {
  if (window.biomarkersHowItWorksLoaded) return;

  window.biomarkersHowItWorksLoaded = true;

  function getStickyCta(section) {
    return section?.querySelector?.('[data-biomarkers-how-sticky-cta]') || section;
  }

  function initStickyCta(stickyCta) {
    if (!stickyCta) return;
    if (!stickyCta.matches?.('[data-biomarkers-how-sticky-cta]')) return;

    if (stickyCta.dataset.biomarkersHowStickyInitialized === 'true') return;

    const stickyCtaGlass = stickyCta.querySelector('.biomarkers-how__sticky-cta-glass');

    if (!stickyCtaGlass) return;

    stickyCta.dataset.biomarkersHowStickyInitialized = 'true';

    const stickyController = new AbortController();
    stickyCta.biomarkersHowStickyController = stickyController;
    const fixedCtaGlass = stickyCtaGlass.cloneNode(true);
    fixedCtaGlass.classList.add('biomarkers-how__sticky-cta-glass--fixed');
    fixedCtaGlass.setAttribute('aria-hidden', 'true');

    const stickyCtaLink = stickyCtaGlass.querySelector('.biomarkers-how__sticky-cta-link');
    const fixedCtaLink = fixedCtaGlass.querySelector('.biomarkers-how__sticky-cta-link');
    const footer =
      document.getElementById('footer-group') ||
      document.querySelector('footer[role="contentinfo"], footer');

    // The CTA is position: fixed, so it renders identically anywhere in the body.
    // Sitting ahead of the footer keeps it out of the tail of the tab order.
    const footerSibling = footer?.closest('body > *') ?? null;
    document.body.insertBefore(fixedCtaGlass, footerSibling);

    let isFixedCtaVisible = false;
    let expandTimer;

    stickyCtaGlass.setAttribute('aria-hidden', 'true');
    if (stickyCtaLink) {
      stickyCtaLink.tabIndex = -1;
    }

    if (fixedCtaLink) {
      fixedCtaLink.tabIndex = -1;
    }

    function setFixedCtaVisible(isVisible) {
      if (isFixedCtaVisible === isVisible) return;

      // Hiding the CTA makes it inert, so hand focus back to the section it
      // belongs to rather than letting it fall to the top of the document.
      if (!isVisible && fixedCtaLink && document.activeElement === fixedCtaLink) {
        const section = stickyCta.closest('.biomarkers-how');

        if (section instanceof HTMLElement) {
          section.focus({ preventScroll: true });
        } else {
          fixedCtaLink.blur();
        }
      }

      isFixedCtaVisible = isVisible;
      window.clearTimeout(expandTimer);
      fixedCtaGlass.classList.toggle('is-visible', isVisible);
      fixedCtaGlass.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

      if (fixedCtaLink) {
        fixedCtaLink.tabIndex = isVisible ? 0 : -1;
      }

      if (!isVisible) {
        fixedCtaGlass.classList.remove('is-expanded');
        return;
      }

      expandTimer = window.setTimeout(() => {
        fixedCtaGlass.classList.add('is-expanded');
      }, 300);
    }

    function updateStickyCtaState() {
      const section = stickyCta.closest('.biomarkers-how') || stickyCta;
      const sectionRect = section.getBoundingClientRect();
      const fixedStyles = window.getComputedStyle(fixedCtaGlass);
      const bottomOffset = parseFloat(fixedStyles.insetBlockEnd || fixedStyles.bottom) || 48;
      const stickySlotTop = window.innerHeight - bottomOffset - 80;
      const footerRect = footer?.getBoundingClientRect();
      const fixedCtaCenter = window.innerHeight - bottomOffset - fixedCtaGlass.offsetHeight / 2;
      const isHalfwayIntoFooter = footerRect ? footerRect.top <= fixedCtaCenter : false;
      const hasReachedSection = sectionRect.top <= stickySlotTop;

      setFixedCtaVisible(hasReachedSection && !isHalfwayIntoFooter);
    }

    updateStickyCtaState();

    const handleScroll = updateStickyCtaState;
    const handleResize = updateStickyCtaState;

    stickyCta.biomarkersHowStickyCleanup = () => {
      window.clearTimeout(expandTimer);
      stickyCta.biomarkersHowStickyController?.abort();
      fixedCtaGlass.remove();
      delete stickyCta.dataset.biomarkersHowStickyInitialized;
      delete stickyCta.biomarkersHowStickyController;
      delete stickyCta.biomarkersHowStickyCleanup;
    };

    window.addEventListener('scroll', handleScroll, {
      passive: true,
      signal: stickyController.signal,
    });
    window.addEventListener('resize', handleResize, { signal: stickyController.signal });
  }

  function initAll() {
    const stickyCtas = document.querySelectorAll('[data-biomarkers-how-sticky-cta]');

    for (const stickyCta of stickyCtas) {
      initStickyCta(stickyCta);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const stickyCta = getStickyCta(event.target);
    initStickyCta(stickyCta);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const stickyCta = getStickyCta(event.target);
    stickyCta?.biomarkersHowStickyCleanup?.();
  });
})();
